import { PrimaryButton } from '@designsforhealth/dfh-react-components'
import React, { FC } from 'react'
import styled from 'styled-components'

import type { GetProductsQueryResults, UseProducts } from '../../../lib/products'

export interface LoadMoreProductsProps {
  className?: string
  loading: boolean
  pagination: UseProducts['pagination']
  products?: GetProductsQueryResults | null
}

const LoadMoreProducts: FC<LoadMoreProductsProps> = ({
  className,
  loading,
  pagination,
  products,
}) => {
  const { data, actions } = pagination
  const { lastPage } = data
  const { fetchNextPage } = actions

  const meta = products?.meta

  const showLoadMoreButton =
    !!meta?.pagination.totalPages && meta?.pagination.totalPages !== lastPage

  return (
    <div className={className}>
      {loading ? (
        <div className="loading-products">LOADING PRODUCTS...</div>
      ) : (
        showLoadMoreButton && (
          <PrimaryButton text="Load more products" onClick={() => fetchNextPage()} />
        )
      )}
    </div>
  )
}

LoadMoreProducts.defaultProps = {
  className: '',
  products: null,
}

const StyledLoadMoreProducts = styled(LoadMoreProducts)({
  marginBottom: '30px',
  marginTop: '30px',
  textAlign: 'center',
  '.loading-products': {
    padding: '15px 0',
  },
})

export default StyledLoadMoreProducts
